import { render, staticRenderFns } from "./Tab-shipments.vue?vue&type=template&id=3d4bfa43"
import script from "./Tab-shipments.vue?vue&type=script&lang=js"
export * from "./Tab-shipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports